// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__197og","inner":"Form_inner__oCeTz","range":"Form_range__3tvUE","name":"Form_name__yWFEA","actions":"Form_actions__3rnoE"};